<template>
    <modal
        :adaptive="true"
        height="auto"
        name="connectIntegration"
        style="z-index: 1071"
    >
        <d-row>
            <d-col lg="12">
                <d-card class="card card-post mx-auto">
                    <d-form id="connectIntegraion" @submit.prevent="submitForm">
                        <d-card-body>
                            <h5>
                                {{
                                    modalType.name ===
                                    modalTypes.CONNECT_VIA_OAUTH.name
                                        ? "Connect"
                                        : "Update"
                                }}
                                Google Analytics integration
                            </h5>
                            <d-col class="mb-3">
                                <div
                                    v-if="
                                        modalType.name ===
                                            modalTypes.CONNECT_VIA_OAUTH.name ||
                                            modalType.name ===
                                                modalTypes
                                                    .UPDATE_VIA_OAUTH_CONNECTION
                                                    .name
                                    "
                                >
                                    <div class="form-group">
                                        <label>Account</label>
                                        <d-form-select
                                            required
                                            :value="formData.service.name"
                                            v-model="formData.service"
                                        >
                                            <option
                                                v-for="service in services"
                                                :value="service"
                                                >{{ service.name }}</option
                                            >
                                        </d-form-select>
                                    </div>
                                    <div class="form-group">
                                        <label>Property</label>
                                        <d-form-select
                                            required
                                            v-model="formData.property"
                                        >
                                            <option
                                                v-for="property in formData.properties"
                                                :value="property"
                                                >{{ property.name }}</option
                                            >
                                        </d-form-select>
                                    </div>
                                    <div class="form-group">
                                        <label>View</label>
                                        <d-form-select
                                            required
                                            v-model="formData.profile"
                                        >
                                            <option
                                                v-for="profile in formData.profiles"
                                                :value="profile"
                                                >{{ profile.name }}</option
                                            >
                                        </d-form-select>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="form-group">
                                        <label>Google Tracking ID</label>
                                        <d-input required v-model="googleId" />
                                    </div>
                                </div>
                                <h6>Advanced settings</h6>
                                <div class="form-group d-flex">
                                    <label>
                                        Force Landing & Exit page tracking
                                        &nbsp;
                                    </label>
                                    <span
                                        class="material-icons mr-3"
                                        v-d-tooltip="
                                            'When enabling Force Landing & Exit page tracking we will always push transaction values to the corresponding Landing- & Exit pages. Even if the transaction was not generated within the same session.'
                                        "
                                    >
                                        help
                                    </span>
                                    <toggle-button
                                        v-model="isAlwaysPushPageViews"
                                        :labels="true"
                                    />
                                </div>
                                <div class="form-group">
                                    <b-form-group
                                        label="Push disapproved transactions as negatives"
                                    >
                                        <b-form-radio
                                            v-model="selectedCronTime"
                                            name="pushed-disapproved-negatives-cron"
                                            :value="null"
                                        >
                                            Off
                                        </b-form-radio>
                                        <b-form-radio
                                            v-model="selectedCronTime"
                                            name="pushed-disapproved-negatives-cron"
                                            value="* * * * *"
                                        >
                                            Realtime
                                        </b-form-radio>
                                        <b-form-radio
                                            v-model="selectedCronTime"
                                            name="pushed-disapproved-negatives-cron"
                                            :value="
                                                selectedCronTimeCronForWeekDay
                                            "
                                        >
                                            On specific day of the week
                                            <b-form-select
                                                class="d-inline-block"
                                                v-model="selectedCronTime"
                                                :options="optionsCronForWeek"
                                            ></b-form-select>
                                        </b-form-radio>
                                        <b-form-radio
                                            v-model="selectedCronTime"
                                            name="pushed-disapproved-negatives-cron"
                                            value="* 20 1 * *"
                                        >
                                            First day of the month
                                        </b-form-radio>
                                    </b-form-group>
                                </div>
                            </d-col>
                        </d-card-body>
                        <d-card-footer class="d-flex justify-content-center">
                            <d-button type="submit" class="btn btn-success">{{ modalType.buttonText }}</d-button>
                            <button type="button" v-if="config" @click="disconnectIntegration" class="btn btn-danger ml-3">Disconnect</button>
                            <button type="button" v-if="hasGoogleConnection && !config" @click="removeGoogleConnection($route.params.id)" class="btn btn-danger ml-3">Disconnect</button>
                        </d-card-footer>
                    </d-form>
                </d-card>
            </d-col>
        </d-row>
    </modal>
</template>

<script>
import {
    GaService,
    GoogleAnalyticsOAuthService,
    WebsiteService,
    ErrorService
} from "@/main";
import modalTypes from "@/components/integrations/google-analytics-oauth/modalTypes";
import notification from "@/mixins/notification";
import * as Sentry from "@sentry/browser";

export default {
    mixins: [notification],
    name: "GoogleAnalyticsForm",
    props: {
        receivedModalType: {
            type: Object,
            required: true
        },
        hasGoogleConnection: {
            type: Boolean,
            required: false
        },
        config: {
            type: Object,
            required: false
        },
        services: {
            type: Array,
            required: false
        }
    },
    data() {
        return {
            selectedCronTime: null,
            optionsCronForWeek: [
                {
                    value: "* 20 * * 1",
                    text: "Monday"
                },
                {
                    value: "* 20 * * 2",
                    text: "Tuesday"
                },
                {
                    value: "* 20 * * 3",
                    text: "Wednesday"
                },
                {
                    value: "* 20 * * 4",
                    text: "Thursday"
                },
                {
                    value: "* 20 * * 5",
                    text: "Friday"
                },
                {
                    value: "* 20 * * 6",
                    text: "Saturday"
                },
                {
                    value: "* 20 * * 0",
                    text: "Sunday"
                }
            ],
            modalTypes: modalTypes,
            modalType: this.receivedModalType,
            googleId: null,
            websiteId: this.$route.params.id,
            isAlwaysPushPageViews: false,
            formData: {
                properties: [],
                profiles: [],
                service: {},
                property: {},
                profile: {}
            }
        };
    },

    computed: {
        selectedCronTimeCronForWeekDay() {
            let selectedCronTime = this.optionsCronForWeek.findIndex(
                option => option.value === this.selectedCronTime
            );
            return selectedCronTime !== -1
                ? this.selectedCronTime
                : this.optionsCronForWeek[0].value;
        }
    },

    watch: {
        services: function(services) {
            if (!this.config) {
                return
            }
            this.fillInDataInSelectForm(
                this.config.profile_id,
                this.config.google_id,
                services
            );
        },

        "formData.service": function() {
            this.formData.properties = this.formData.service.properties;
            this.formData.profiles = [];
        },

        "formData.property": function() {
            this.formData.profiles = this.formData.property.profiles;
        }
    },

    methods: {
        submitForm() {
            switch (this.modalType.name) {
                case modalTypes.CONNECT_VIA_OAUTH.name: {
                    this.connectGoogleAnalyticsOAuthIntegration();
                    break;
                }
                case modalTypes.UPDATE_GOOGLE_ID_CONNECTION.name: {
                    this.updateConnection();
                    break;
                }
                case modalTypes.UPDATE_VIA_OAUTH_CONNECTION.name: {
                    this.updateGoogleAnalyticsOAuthIntegration();
                    break;
                }
                default:
                    break;
            }
        },

        showForm(type) {
            this.modalType = type;
            this.$modal.show("connectIntegration");
        },

        closeForm() {
            this.$modal.hide("connectIntegration");
        },

        async connect() {
            try {
                await GaService.connect(
                    this.websiteId,
                    this.googleId,
                    this.isAlwaysPushPageViews,
                    this.selectedCronTime
                );
                this.showNotification(
                    "success",
                    "Alert",
                    "Google Analytics successfully connected!"
                );
                this.$router.go();
            } catch (e) {
                this.showNotification(
                    "error-notification",
                    "Oops! We have a problem",
                    ErrorService.getErrorMessage(
                        e.networkError.result.errors[0]
                    )
                );
                Sentry.captureException(e);
                console.log(e);
            }
        },

        async connectGoogleAnalyticsOAuthIntegration() {
            try {
                await GoogleAnalyticsOAuthService.connectGoogleAnalyticsOAuthIntegration(
                    this.websiteId,
                    this.formData.property.id,
                    this.formData.profile.id,
                    this.isAlwaysPushPageViews,
                    this.selectedCronTime
                );
                this.showNotification(
                    "success",
                    "Alert",
                    "Google Analytics successfully connected via OAuth !"
                );
                this.$router.go();
            } catch (e) {
                this.showNotification(
                    "error-notification",
                    "Oops! We have a problem",
                    ErrorService.getErrorMessage(
                        e.networkError.result.errors[0]
                    )
                );
                Sentry.captureException(e);
                console.log(e);
            }
        },

        async updateConnection() {
            try {
                await GaService.updateConnection(
                    this.websiteId,
                    this.googleId,
                    this.isAlwaysPushPageViews,
                    this.selectedCronTime
                );
                this.$eventHub.$emit("close-google-analytics-form");
                this.showNotification(
                    "success",
                    "Alert",
                    "Google Analytics settings successfully updated!"
                );
                this.$router.go();
            } catch (e) {
                this.showNotification(
                    "error-notification",
                    "Oops! We have a problem",
                    ErrorService.getErrorMessage(
                        e.networkError.result.errors[0]
                    )
                );
                Sentry.captureException(e);
                console.log(e);
            }
        },

        async updateGoogleAnalyticsOAuthIntegration() {
            try {
                await GoogleAnalyticsOAuthService.updateGoogleAnalyticsOAuthIntegration(
                    this.websiteId,
                    this.formData.property.id,
                    this.formData.profile.id,
                    this.isAlwaysPushPageViews,
                    this.selectedCronTime
                );
                this.showNotification(
                    "success",
                    "Alert",
                    "Google Analytics settings successfully updated!"
                );
                this.$eventHub.$emit("close-google-analytics-form");
                this.$router.go();
            } catch (e) {
                this.showNotification(
                    "error-notification",
                    "Oops! We have a problem",
                    ErrorService.getErrorMessage(
                        e.networkError.result.errors[0]
                    )
                );
                Sentry.captureException(e);
                console.log(e);
            }
        },

        async disconnectIntegration() {
            try {
                if (this.hasGoogleConnection) {
                    await GoogleAnalyticsOAuthService.removeGoogle(
                        this.$route.params.id
                    );
                }
                this.$eventHub.$emit("close-google-analytics-form");
                await WebsiteService.disconnectIntegration(
                    this.websiteId,
                    "googleAnalytics"
                );
                this.showNotification(
                    "success",
                    "Alert",
                    "Integration successfully disconnected!"
                );
                this.$router.go();
            } catch (e) {
                this.showNotification(
                    "warn",
                    "Oops! we have a problem",
                    "Can not remove integration"
                );
                Sentry.captureException(e);
                console.log(e);
            }
        },

        async removeGoogleConnection() {
            try {
                await GoogleAnalyticsOAuthService.removeGoogle(
                    this.$route.params.id
                );
                this.$eventHub.$emit("close-google-analytics-form");
                this.showNotification(
                    "success",
                    "Alert",
                    "Google connection successfully disconnected!"
                );
                this.$router.go();
            } catch (e) {
                this.showNotification(
                    "warn",
                    "Oops! we have a problem",
                    "Can not remove google connection"
                );
                Sentry.captureException(e);
                console.log(e);
            }
        },

        fillInDataInSelectForm(profile_id, google_id, services) {
            if (!profile_id && !google_id) {
                return;
            }
            const serviceId = Number(
                google_id.replace("UA-", "").split("-")[0]
            );
            const service = services.find(el => el.id === serviceId);
            if (service) {
                this.formData.service = service;
            }
            let property = null;
            if (google_id) {
                if (service) {
                    property = service.properties.find(
                        el => el.id === google_id
                    );
                }
                if (property) {
                    this.formData.property = property;
                }
            }

            if (profile_id) {
                let profile = null;
                if (property) {
                    profile = property.profiles.find(
                        el => el.id === profile_id
                    );
                }
                if (profile) {
                    this.formData.profile = profile;
                }
            }
        }
    },

    mounted() {
        if (this.config) {
            if (this.config.google_id) {
                this.googleId = this.config.google_id;
            }

            if (this.config.is_always_push_page_views) {
                this.isAlwaysPushPageViews = this.config.is_always_push_page_views;
            }

            if (this.config.send_disapprove_transactions) {
                this.selectedCronTime = this.config.send_disapprove_transactions;
            }
        }
        this.$eventHub.$on("close-google-analytics-form", this.closeForm);
        this.$eventHub.$on("show-google-analytics-form", type =>
            this.showForm(type)
        );
    }
};
</script>
